import "inputmask/dist/jquery.inputmask"

export function attachInputMask($context) {
    $context.find(".input-mask").inputmask();
}
